<script>
  import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
  import _isEmpty from 'lodash/isEmpty'
  import {
    documentMethods,
  } from '@state/helpers'

  export default {
    components: {
      VueTypeaheadBootstrap,
    },
    props: {
      blockFilters: {
        type: Array,
        default: () => ['docTypesFilter', 'contactsFilter', 'recipientsFilter'],
      },
    },
    data() {
      return {
        contacts: [],
        recipients: [],
        docTypes: [],
        contactsFilter: null,
        contactsFilterRaw: null,
        recipientsFilter: null,
        recipientsFilterRaw: null,
        boundCollapse: {
          type: true,
          recipients: true,
          contacts: true,
        },
      }
    },
    computed:{
      docTypesFilters(){
        return this.docTypes.map(el => {
          if (el.selected){
            return el.type
          }
        }).filter(el => el)
      }
    },
    watch: {
      contactsFilter (val) {
        this.$emit('filter', {
          contact: val,
        })
      },
      recipientsFilter (val) {
        this.$emit('filter', {
          send_to: val,
        })
      },
      docTypesFilters (val) {
        this.$emit('filter', {
          types: val.toString(),
        })
      },
    },
    async created() {
      this.getDocumentFilters()
    },
    methods: {
      ...documentMethods,
      _isEmpty,
      async getDocumentFilters() {
        const { data } = await this.resolveDocumentFilters()
        if (data.Contact){
          this.contacts = data.Contact.filter(el => el.contact !== null)
        }
        if (data['Send To']){
          this.recipients = data['Send To'].filter(el => el.send_to !== null)
        }
        if (data.Types){
          const types = data.Types
          types.forEach(el => el.selected = false)
          this.docTypes = types
        }
      },

      clearFilter(filterKey){
        const checkRaw = filterKey !== 'docTypesFilter'
        if ((this[filterKey] === null || this._isEmpty(this[filterKey]))
          && (checkRaw && (this[`${filterKey}Raw`] === null || this._isEmpty(this[`${filterKey}Raw`])))
        ){
          return
        }
        switch(filterKey) {
          case "docTypesFilter":
            this.docTypes.forEach(el => el.selected = false)
            break
          case "contactsFilter":
            this[filterKey] = null
            this.contactsFilterRaw = null
            break
          case "recipientsFilter":
            this[filterKey] = null
            this.recipientsFilterRaw = null
            break
          default:
            break
        }
      },
      checkInput(event, filter){
        if (event === ""){
          this.clearFilter(filter)
        }
      },
      checkEnableFilterBlock(blockType) {
        return this.blockFilters.indexOf(blockType) !== -1;
      },
    },
  }
</script>

<template>
  <section>
    <div v-if="checkEnableFilterBlock('docTypesFilter')" v-bind="$attrs" class="block-item">
      <div class="block-heading">
        <h3
          v-fabric-collapse.accordion-docType
          class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
          <a class="tw-no-underline" href="javascript:">Document Type</a>
          <BaseChevronRotate
            transition-class="rotate-360-270"
            :toggle="!boundCollapse.type"
            :duration="500"
          />
        </h3>
        <h3
          class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base"><a href="#" class="tw-no-underline" @click="clearFilter('docTypesFilter')">Clear</a></h3>
      </div>
      <FabricCollapse
        id="accordion-docType"
        v-model="boundCollapse.type"
        hide-header
        :duration="500"
        default-shown
        class="table-filters">
        <div class="block-content not-custom">
          <FabricCheckbox
            v-for="type in docTypes" 
            :key="type.type"
            v-model="type.selected"
            slot-classes="tw-pl-3 tw-text-black"
          >{{ resolveTypeForDocument(type.type) }}</FabricCheckbox>
        </div>
      </FabricCollapse>
    </div>
    <div v-if="checkEnableFilterBlock('recipientsFilter')" v-bind="$attrs" class="block-item">
      <div class="block-heading">
        <h3
          v-fabric-collapse.accordion-recipient
          class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
          <a class="tw-no-underline" href="javascript:">Recipients</a>
          <BaseChevronRotate
            transition-class="rotate-360-270"
            :toggle="!boundCollapse.recipients"
            :duration="500"
          />
        </h3>
        <h3
          class="
            tw-flex tw-items-center
            tw-text-positive
            tw-leading-relaxed tw-font-medium tw-text-base"><a href="#" class="tw-no-underline" @click="clearFilter('recipientsFilter')">Clear</a></h3>
      </div>
      <FabricCollapse
        id="accordion-recipient"
        v-model="boundCollapse.recipients"
        hide-header
        :duration="500"
        default-shown
        class="table-filters">
        <div class="block-content">
          <VueTypeaheadBootstrap
            v-model="recipientsFilterRaw"
            placeholder="Search Recipient..."
            :serializer="s => s.key"
            :data="recipients"
            input-class="input-type-ahead"
            @hit="recipientsFilter = $event.key"
            @input="checkInput($event, 'recipientsFilter')"
          />
        </div>
      </FabricCollapse>
    </div>
    <div v-if="checkEnableFilterBlock('contactsFilter')" v-bind="$attrs" class="block-item !tw-border-b-0">
      <div class="block-heading">
        <h3
          v-fabric-collapse.accordion-contact
          class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
          <a class="tw-no-underline" href="javascript:">Contacts</a>
          <BaseChevronRotate
            transition-class="rotate-360-270"
            :toggle="!boundCollapse.contacts"
            :duration="500"
          />
        </h3>
        <h3
          class="
            tw-flex tw-items-center
            tw-text-positive
            tw-leading-relaxed tw-font-medium tw-text-base"><a href="#" class="tw-no-underline" @click="clearFilter('contactsFilter')">Clear</a></h3>
      </div>
      <FabricCollapse
        id="accordion-contact"
        v-model="boundCollapse.contacts"
        hide-header
        :duration="500"
        default-shown
        class="table-filters">
        <div class="block-content">
          <VueTypeaheadBootstrap
            v-model="contactsFilterRaw"
            placeholder="Search Customer..."
            :serializer="s => s.key"
            :data="contacts"
            input-class="input-type-ahead"
            @hit="contactsFilter = $event.key"
            @input="checkInput($event, 'contactsFilter')"
          />
        </div>
      </FabricCollapse>
    </div>
  </section>
</template>
